import { SummerSchoolListContainer } from './../../../ng2/school/lists/summer-school-list/summer-school-list.component';
import { RegentsExemptionsListContainer } from './../../../ng2/school/lists/regents-exemptions-list/regents-exemptions-list.component';
import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NetworkTopLevelComponent } from 'Src/ng2/network/network-top-level/network-top-level.component';
import { NetworkLeftSideNavComponent } from 'Src/ng2/network/network-left-side-nav/network-left-side-nav.component';
import { NetworkMidLevelComponent } from 'Src/ng2/network/network-mid-level/network-mid-level.component';
import { AssessmentsDataInputComponent } from 'Src/ng2/school/data-entry/assessments/assessments-data-input/assessments-data-input.component';
import { OtherToolsResourcesComponent } from 'Src/ng2/school/school-tools/other-tools/other-tools-resources/other-tools-resources.component';
import { StudentLevelDashComponent } from 'Src/ng2/school/student-level-dashboard/student-level-dash.component';
import { NetworkSettingsComponent } from '../../../ng2/network/network-settings/network-settings.component';
import { NetworkStudentLevelComponent } from '../../../ng2/network/network-student-level/network-student-level.component';
import { DataEntryComponent } from '../../../ng2/school/data-entry/data-entry.component';
import { GraphListComponent } from '../../../ng2/school/graph-list/graph-list.component';
import { AcademicListComponent } from '../../../ng2/school/lists/academic-list/academic-list.component';
import { AttendanceListComponent } from '../../../ng2/school/lists/attendance-list/attendance-list.component';
import { MyStudentsListComponent } from '../../../ng2/school/lists/my-students-list/my-students-list.component';
import { PostsecondaryListComponent } from '../../../ng2/school/lists/postsecondary-list/postsecondary-list.component';
import { MidLevelDashComponent } from '../../../ng2/school/mid-level-dashboard/mid-level-dash.component';
import { OtherToolsLeftNavComponent } from '../../../ng2/school/school-tools/other-tools/other-tools-left-nav/other-tools-left-nav.component';
import { OtherToolsComponent } from '../../../ng2/school/school-tools/other-tools/other-tools.component';
import { TilesComponent } from '../../../ng2/school/tiles/tiles.component';
import { ExitViewComponent } from '../../../ng2/shared/components/exit-view/exit-view.component';
import { ContentToolsComponent } from '../../../ng2/shell/content-tools/content-tools.component';
import { SdcNavComponent } from '../../../ng2/shell/sdc-nav/sdc-nav.component';
import { SideNavNgComponent } from '../../../ng2/shell/side-nav/side-nav.component';
import { DataUploadsComponent } from './../../../ng2/school/data-uploads/data-uploads.component';
import { GraphDetailComponent } from './../../../ng2/school/graph-detail/graph-detail.component';
import { AcademicListContainer } from './../../../ng2/school/lists/academic-list-v2/academic-list-v2.component';
import { AttendanceListContainer } from './../../../ng2/school/lists/attendance-list-v2/attendance-list-v2.component';
import { PostsecondaryListContainer } from './../../../ng2/school/lists/postsecondary-list-v2/postsecondary-list-v2.component';
import { StudentsListContainer } from './../../../ng2/school/lists/students-list-v2/students-list-v2.component';
import { PrivacyAndTermsComponent } from './../../../ng2/shared/components/privacy-and-terms/privacy-and-terms.component';
import { SettingsComponent } from './../../../ng2/shared/components/settings/settings.component';
import { LoginComponent } from './../../../ng2/shell/login/login.component';
import { StudentComponent } from './../../../ng2/student/student.component';

export const downgradedComponents = angular
  .module('downgraded-components', [])
  .directive(
    'login',
    downgradeComponent({
      component: LoginComponent,
    }),
  )
  // todo: rmeove this when we get rid of UI router. (Assuming, of course, the components are not
  // used in v2) - DVN
  // If you're wondering why we are downgrading v3 components, mostly because we rely on UI router (DVN)
  .directive(
    'nvpsMyStudentsList',
    downgradeComponent({
      component: MyStudentsListComponent,
    }),
  )
  .directive(
    'studentsListV2',
    downgradeComponent({
      component: StudentsListContainer,
    }),
  )
  .directive(
    'nvpsAttendanceList',
    downgradeComponent({
      component: AttendanceListComponent,
    }),
  )
  .directive(
    'nvpsAcademicList',
    downgradeComponent({
      component: AcademicListComponent,
    }),
  )
  .directive(
    'academicListV2',
    downgradeComponent({
      component: AcademicListContainer,
    }),
  )
  .directive(
    'attendanceListV2',
    downgradeComponent({
      component: AttendanceListContainer,
    }),
  )
  .directive(
    'nvpsPostsecondaryList',
    downgradeComponent({
      component: PostsecondaryListComponent,
    }),
  )
  .directive(
    'postsecondaryListV2',
    downgradeComponent({
      component: PostsecondaryListContainer,
    }),
  )
  .directive(
    'regentsExemptionsList',
    downgradeComponent({
      component: RegentsExemptionsListContainer,
    }),
  )
  .directive(
    'summerSchoolList',
    downgradeComponent({
      component: SummerSchoolListContainer,
    }),
  )
  .directive(
    'nvpsSideNav',
    downgradeComponent({
      component: SideNavNgComponent,
    }),
  )
  .directive(
    'otherTools',
    downgradeComponent({
      component: OtherToolsComponent,
    }),
  )
  .directive(
    'otherToolsLeftNav',
    downgradeComponent({
      component: OtherToolsLeftNavComponent,
    }),
  )
  .directive(
    'otherToolsResources',
    downgradeComponent({
      component: OtherToolsResourcesComponent,
    }),
  )
  .directive(
    'student',
    downgradeComponent({
      component: StudentComponent,
    }),
  )
  .directive(
    'contentTools',
    downgradeComponent({
      component: ContentToolsComponent,
    }),
  )
  .directive(
    'nvpsSdcNav',
    downgradeComponent({
      component: SdcNavComponent,
    }),
  )
  .directive(
    'graphDetail',
    downgradeComponent({
      component: GraphDetailComponent,
    }),
  )
  .directive(
    'graphList',
    downgradeComponent({
      component: GraphListComponent,
    }),
  )
  .directive(
    'exitView',
    downgradeComponent({
      component: ExitViewComponent,
    }),
  )
  .directive(
    'privacyAndTerms',
    downgradeComponent({
      component: PrivacyAndTermsComponent,
    }),
  )
  .directive(
    'tiles',
    downgradeComponent({
      component: TilesComponent,
    }),
  )
  .directive(
    'studentLevelDash',
    downgradeComponent({
      component: StudentLevelDashComponent,
    }),
  )
  .directive(
    'midLevelDash',
    downgradeComponent({
      component: MidLevelDashComponent,
    }),
  )
  .directive(
    'settings',
    downgradeComponent({
      component: SettingsComponent,
    }),
  )
  .directive(
    'nvDataEntry',
    downgradeComponent({
      component: DataEntryComponent,
    }),
  )
  .directive(
    'nvDataUploads',
    downgradeComponent({
      component: DataUploadsComponent,
    }),
  )
  .directive(
    'assessmentsDataInput',
    downgradeComponent({
      component: AssessmentsDataInputComponent,
    }),
  )
  .directive(
    'networkLeftSideNav',
    downgradeComponent({
      component: NetworkLeftSideNavComponent,
    }),
  )
  .directive(
    'networkTopLevel',
    downgradeComponent({
      component: NetworkTopLevelComponent,
    }),
  )
  .directive(
    'networkMidLevel',
    downgradeComponent({
      component: NetworkMidLevelComponent,
    }),
  )
  .directive(
    'networkStudentLevel',
    downgradeComponent({
      component: NetworkStudentLevelComponent,
    }),
  )
  .directive(
    'networkSettings',
    downgradeComponent({
      component: NetworkSettingsComponent,
    }),
  ).name;
